import React, { useEffect, useContext } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';

function ModalRestoreSale() {
  const { t } = useTranslation();

  const {
    updateFocusOnMainScreen,
    pendingSnapshot,
    restorePendingSnapshot,
    discardPendingSnapshot,
  } = useContext(AppContext);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  if (!pendingSnapshot) {
    return null;
  }

  const user = pendingSnapshot.user || {};
  const sale = pendingSnapshot.sale || {};
  const userInfo = user.userInfo || {};

  const clientName = [userInfo.firstname, userInfo.lastname]
    .filter((part) => Boolean(part))
    .join(' ');

  const savedAt = new Date(pendingSnapshot.savedAt).toLocaleString('nb-NO', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });

  const restore = () => {
    restorePendingSnapshot();
    updateFocusOnMainScreen(true);
  };

  const discard = () => {
    discardPendingSnapshot();
    updateFocusOnMainScreen(true);
  };

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body" style={{ width: '1000px' }}>
            <h1>{t('sales.restoreSaleTitle')}</h1>
            <p>{t('sales.restoreSaleText1')}</p>
            <p>
              {t('sales.restoreSaleClient')}
              <strong>
                {clientName || user.currentUser || t('sales.restoreSaleNoUser')}
              </strong>
            </p>
            <p>
              {t('sales.restoreSaleOperator')}
              <strong>{pendingSnapshot.operator}</strong>
              {' — '}
              {t('sales.restoreSaleTime')}
              <strong>{savedAt}</strong>
            </p>
            <p>
              {t('sales.restoreSaleLines')}
              <strong>
                {sale.transactions ? sale.transactions.length : 0}
              </strong>
              {' — '}
              {t('sales.restoreSaleTotal')}
              <strong>{sale.total || 0} kr</strong>
            </p>
            <p>{t('sales.restoreSaleQuestion')}</p>
            <div
              className="react-confirm-alert-button-group"
              style={{ marginTop: '55px' }}
            >
              <button
                className="btn-custom-yes"
                onClick={() => {
                  restore();
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                <CheckCircleIcon style={{ fontSize: '1.2em' }} />
                {t('sales.restoreSaleYes')}
              </button>
              <button
                className="btn-custom-no"
                onClick={() => {
                  discard();
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                <CancelIcon style={{ fontSize: '1.2em' }} />
                {t('sales.restoreSaleNo')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalRestoreSale;
